import React from "react";
import { IPartnerMenuItem } from "../../../../interfaces/menu";
import styles from "./ItemCard.module.scss";

interface IProps {
  item: IPartnerMenuItem;
  onTap: React.MouseEventHandler;
}

const ItemCard: React.FC<IProps> = ({ item, onTap }) => {
  // console.log(item);
  return (
    <div className={styles.item_card_container} onClick={onTap}>
      {/* {item.ItemImageUrl && (
        <div className={styles.image_container}>
          <img src={item.ItemImageUrl} alt={item.ItemName} />
        </div>
      )} */}

      <div className={styles.image_container}>
        <img
          src="https://www.beveragedaily.com/var/wrbm_gb_food_pharma/storage/images/publications/food-beverage-nutrition/beveragedaily.com/news/retail-shopper-insights/premium-soft-drinks-and-mixer-trends-fentimans/12029608-4-eng-GB/Premium-soft-drinks-and-mixer-trends-Fentimans.jpg"
          alt={item.ItemName}
        />
        <div className={styles.item_details}>
          <div className={styles.item_title}>
            <span>{item.ItemName}</span>
          </div>
          <div className={styles.item_price}>
            <span>Rs.{item.SalesPrice.toFixed(2)}</span>
          </div>
        </div>
      </div>

      {/* <div className={styles.title}>
        <div className={styles.item_title}>
          <span>{item.ItemName}</span>
        </div>
        <div className={styles.item_price}>
          <span>Rs.{item.SalesPrice.toFixed(2)}</span>
        </div>
      </div> */}
    </div>
  );
};

export default ItemCard;
